import type { FC, PropsWithChildren } from "react";

import { DEPRECATED_IconButton } from "@ui/components/DEPRECATED_IconButton";
import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";

import { useHeaderContext } from "../../context";

import styles from "./SecondaryNavigation.module.scss";

export type SecondaryNavigationProps = {
  className?: string;
};

export const SecondaryNavigation: FC<PropsWithChildren<SecondaryNavigationProps>> = ({ children, className }) => {
  const { onClick } = useHeaderContext();
  const { __ } = useTranslations();
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.innerWrapper}>
        {children}
        <DEPRECATED_IconButton className={styles.closeButton} onClick={onClick} icon={ChevronUpIcon} iconPosition="end">
          {__("navigation.button.close")}
        </DEPRECATED_IconButton>
      </div>
    </div>
  );
};
